/* Coco custom variant UI — PEOPLE version (Custom Hand-Drawn Illustration).
   Drives the buy box, syncs with VOPO, and updates the ATC button price
   directly from the shared variant data.
   Background colours are now read dynamically from the `data-bg` attribute
   (set per product in the Liquid snippet).
   Added ATC lock & missing-field badge (background + upload required). */
   (function () {
    var root = document.getElementById('coco-cvb');
    if (!root || root.dataset.cocoInit) return;
    root.dataset.cocoInit = '1';
  
    // Shared data
    var DATA = window.CocoVariantPickerData || {};
    var VARS = DATA.variants || [];
    var FAVAIL = DATA.framingAvailability || [];
    var PEOPLE = DATA.people || [];
    
    // Deltas still from root dataset (not part of the shared data)
    var DELTAS = {};
    try { DELTAS = JSON.parse(root.dataset.deltas || '{}'); } catch (e) { DELTAS = {}; }
  
    // If people not in shared data (old format fallback)
    if (!PEOPLE.length) {
      VARS.forEach(function (v) { if (PEOPLE.indexOf(v.option1) === -1) PEOPLE.push(v.option1); });
      PEOPLE.sort(function (a, b) { return (parseInt(a, 10) || 0) - (parseInt(b, 10) || 0); });
      if (!PEOPLE.length) PEOPLE = ['1', '2', '3', '4', '5', '6', '7'];
    }
  
    var DIGITAL = 'No Frame - Digital Download (JPG)';
    var RUSH = 'Receive my JPG file in 48 hours or less!';
  
    // Persist state on window so the Impact theme's section re-render (which REPLACES this
    // buy box node on every variant change) cannot reset our selection back to Digital.
    var __PSK = '__cocoPeopleSt_' + (location.pathname || '');
    var st = window[__PSK] || { people: PEOPLE[0], finish: 'digital', colour: 'Oak', rush: false, bg: '' };
    window[__PSK] = st;
    window.__cocoCurrentState = st;          // <-- exposed for any external code
  
    // AUTO-SELECT VARIANT FROM URL PARAMETERS
    (function urlVariantOverride() {
      var params = new URLSearchParams(location.search);
      var variantId = params.get('variant');
      var selectedVariant = null;
  
      // 1. Try ?variant=123456
      if (variantId) {
        for (var i = 0; i < VARS.length; i++) {
          if (VARS[i].id == variantId) {
            selectedVariant = VARS[i];
            break;
          }
        }
      }
  
      // 2. Try ?people=...&finish=...&rush=...
      if (!selectedVariant) {
        var peopleParam = params.get('people');
        var finishParam = params.get('finish');   // framing value
        var rushParam = params.get('rush');       // rush value
  
        if (peopleParam && finishParam && rushParam) {
          var peopleStr = String(peopleParam).trim();
          var finishDecoded = decodeURIComponent(finishParam).replace(/\+/g, ' ');
          var rushDecoded = decodeURIComponent(rushParam).replace(/\+/g, ' ').toLowerCase();
  
          for (var i = 0; i < VARS.length; i++) {
            var v = VARS[i];
            // In People template, option1 = number of people, option2 = rush, option3 = framing
            if (String(v.option1).trim() === peopleStr &&
                v.option3 === finishDecoded &&
                v.option2 === rushDecoded) {
              selectedVariant = v;
              break;
            }
          }
        }
      }
  
      if (selectedVariant) {
        // Parse people count
        st.people = String(selectedVariant.option1).trim();
  
        // Parse finish & colour from the variant's option3 framing string
        var framingStr = selectedVariant.option3;
        if (/no\s*frame|digital/i.test(framingStr)) {
          st.finish = 'digital';
          st.colour = 'Oak';   // default for digital
        } else {
          if (/30\s*x\s*40/i.test(framingStr)) st.finish = '3040';
          else if (/45\s*x\s*60/i.test(framingStr)) st.finish = '4560';
  
          if (/oak/i.test(framingStr)) st.colour = 'Oak';
          else if (/white/i.test(framingStr)) st.colour = 'White';
          else if (/black/i.test(framingStr)) st.colour = 'Black';
        }
  
        // Rush
        st.rush = (/48\s*hours/i.test(selectedVariant.option2));
        console.log('URL variant applied (People):', st);
      }
    })();
  
    (function readNativeIntoSt() {
      if (st.__seeded) return;
      st.__seeded = true;
      try {
        var vp = document.querySelector('variant-picker'); if (!vp) return;
        var rs = vp.querySelectorAll('input[type="radio"]:checked');
        Array.prototype.forEach.call(rs, function (r) {
          if (r.name === 'properties[Background]') return;
          var l = r.closest('label'); var tx = (l ? l.textContent : r.value).replace(/\s+/g, ' ').trim();
          if (/^\d+$/.test(tx)) { st.people = tx; }
          else if (/48\s*hours/i.test(tx)) { st.rush = true; }
          else if (/no frame|digital/i.test(tx)) { st.finish = 'digital'; }
          else if (/30\s*x\s*40/i.test(tx)) { st.finish = '3040'; if (/oak/i.test(tx)) st.colour = 'Oak'; else if (/white/i.test(tx)) st.colour = 'White'; else if (/black/i.test(tx)) st.colour = 'Black'; }
          else if (/45\s*x\s*60/i.test(tx)) { st.finish = '4560'; if (/oak/i.test(tx)) st.colour = 'Oak'; else if (/white/i.test(tx)) st.colour = 'White'; else if (/black/i.test(tx)) st.colour = 'Black'; }
        });
      } catch (e) {}
    })();
  
    var scope = document.querySelector('.product-info') || document;
    function $(s) { return root.querySelector(s); }
    function all(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
    function money(c) { return '$' + (c / 100).toFixed(2); }
  
    // Helper functions: now use option1 (people), option3 (framing), option2 (rush)
    function frameKey(f) {
      if (!f) return 'digital';
      if (f.indexOf('No Frame') === 0 || f.indexOf('No frame') === 0) return 'digital';
      if (f.indexOf('30 x 40') === 0) return '3040';
      if (f.indexOf('45 x 60') === 0) return '4560';
      return 'digital';
    }
    function colourOf(f) {
      if (!f) return '';
      if (f.indexOf('Oak') > -1) return 'Oak';
      if (f.indexOf('White') > -1) return 'White';
      if (f.indexOf('Black') > -1) return 'Black';
      return '';
    }
    function isRush(r) { return (r || '').indexOf('48 hours') > -1; }
    function priceFor(people, rushBool, finish, colour) {
      for (var i = 0; i < VARS.length; i++) {
        var v = VARS[i];
        if (String(v.option1) !== String(people)) continue;
        if (isRush(v.option2) !== !!rushBool) continue;
        if (frameKey(v.option3) !== finish) continue;
        if (finish !== 'digital' && colourOf(v.option3) !== colour) continue;
        return v.price;
      }
      return null;
    }
    function availFor(people, rushBool, finish, colour) {
      for (var i = 0; i < FAVAIL.length; i++) {
        var f = FAVAIL[i].f;
        if (frameKey(f) !== finish) continue;
        if (finish !== 'digital' && colourOf(f) !== colour) continue;
        return FAVAIL[i].a !== false;
      }
      return true;
    }
    function sizeAvail(people, rushBool, finish) {
      if (finish === 'digital') return availFor(people, rushBool, 'digital');
      var cc = ['Oak', 'White', 'Black'];
      for (var i = 0; i < cc.length; i++) { if (availFor(people, rushBool, finish, cc[i])) return true; }
      return false;
    }
    function normalizeSelection() {
      if (st.finish !== 'digital' && !sizeAvail(st.people, st.rush, st.finish)) { st.finish = 'digital'; }
      if (st.finish === '3040' || st.finish === '4560') {
        if (!availFor(st.people, st.rush, st.finish, st.colour)) {
          var cc = ['Oak', 'White', 'Black'];
          for (var i = 0; i < cc.length; i++) { if (availFor(st.people, st.rush, st.finish, cc[i])) { st.colour = cc[i]; break; } }
        }
      }
    }
    function frameVal() {
      if (st.finish === 'digital') return DIGITAL;
      if (st.finish === '3040') return '30 x 40cm ' + st.colour + ' Frame';
      return '45 x 60cm ' + st.colour + ' Frame (Not available in NZ or Canada)';
    }
    function rushVal() { return st.rush ? RUSH : 'No thanks'; }
  
    function setByValue(value) {
      var sels = scope.querySelectorAll('select');
      for (var i = 0; i < sels.length; i++) {
        var s = sels[i];
        for (var j = 0; j < s.options.length; j++) {
          if (s.options[j].value === value) {
            if (s.selectedIndex !== j) { s.selectedIndex = j; s.dispatchEvent(new Event('change', { bubbles: true })); }
            return true;
          }
        }
      }
      var rs = scope.querySelectorAll('input[type="radio"]');
      for (var k = 0; k < rs.length; k++) {
        if (rs[k].name === 'properties[Background]') continue;
        var lbl = rs[k].closest('label');
        var t = (lbl ? lbl.textContent : rs[k].value).replace(/\s+/g, ' ').trim();
        if (rs[k].value === value || t.toLowerCase() === String(value).toLowerCase()) {
          if (!rs[k].checked) { rs[k].checked = true; rs[k].dispatchEvent(new Event('change', { bubbles: true })); }
          return true;
        }
      }
      return false;
    }
    function setBgNative(name) {
      var rs = scope.querySelectorAll('input[type="radio"][name="properties[Background]"]');
      for (var i = 0; i < rs.length; i++) {
        if (rs[i].value === name) {
          if (!rs[i].checked) { rs[i].checked = true; rs[i].dispatchEvent(new Event('change', { bubbles: true })); }
          return true;
        }
      }
      var bsel = scope.querySelector('select[name="properties[Background]"]');
      if (bsel) { for (var j = 0; j < bsel.options.length; j++) { if (bsel.options[j].value === name) { bsel.selectedIndex = j; bsel.dispatchEvent(new Event('change', { bubbles: true })); return true; } } }
      return false;
    }
    function vopoReady() {
      return !!(scope.querySelector('select[name="vopo-id"]') || scope.querySelector('input[name="properties[Background]"]') || scope.querySelector('select[name^="name"]'));
    }
    function syncNative() {
      setByValue(String(st.people));
      setByValue(rushVal());
      setByValue(frameVal());
      if (st.bg) setBgNative(st.bg);
    }
  
    var peopleBtns = PEOPLE.map(function (p) {
      return '<button type="button" class="cvb-pp" data-p="' + p + '">' + p + '</button>';
    }).join('');
  
    root.innerHTML =
      '<style>' +
      '#coco-cvb .cvb-people{ display:flex; flex-wrap:wrap; gap:8px; }' +
      '#coco-cvb .cvb-pp{ min-width:46px; height:46px; padding:0 12px; border:2px solid var(--coco-bx-border,#e6dccf); border-radius:11px; background:var(--coco-bx-card-bg,#fff); font-family:var(--text-font-family); font-size:16px; font-weight:600; color:var(--coco-bx-heading,#2A555A); cursor:pointer; }' +
      '#coco-cvb .cvb-pp.act{ border-color:var(--coco-bx-heading,#2A555A); box-shadow:0 0 0 3px rgba(42,85,90,.1); }' +
      '</style>' +
      '<div class="cvb-lab"><span class="n">1</span> Number of people</div>' +
      '<div class="cvb-people" id="cvb-people">' + peopleBtns + '</div>' +
      '<div class="cvb-lab"><span class="n">2</span> Choose your finish</div>' +
      '<div class="cvb-opt" data-f="digital"><span class="cvb-rad"></span><div><div class="t">Digital download (JPG)</div><div class="d">Print at home or anywhere</div></div><span class="cvb-oos">Sold out</span></div>' +
      '<div class="cvb-opt" data-f="3040"><span class="cvb-rad"></span><div><div class="t">30×40cm framed</div><div class="d">Oak, white or black · ready to hang</div></div><span class="pr" data-pr="3040"></span> <span class="cvb-oos">Sold out</span></div>' +
      '<div class="cvb-opt" data-f="4560"><span class="cvb-rad"></span><div><div class="t">45×60cm framed</div><div class="d">Statement size · ready to hang</div></div><span class="pr" data-pr="4560"></span> <span class="cvb-oos">Sold out</span></div>' +
      '<div class="cvb-colours" id="cvb-col"><div class="cvb-cwrap"><div class="h">Choose your frame colour</div><div class="cvb-sw">' +
      '<div class="cvb-cc" data-c="Oak"><div class="chip" style="background:#caa46f"></div>Oak<span class="cvb-oos">Sold out</span></div>' +
      '<div class="cvb-cc" data-c="White"><div class="chip" style="background:#f3f0ea"></div>White<span class="cvb-oos">Sold out</span></div>' +
      '<div class="cvb-cc" data-c="Black"><div class="chip" style="background:#2c2c2a"></div>Black<span class="cvb-oos">Sold out</span></div>' +
      '</div></div></div>' +
      '<div class="cvb-lab"><span class="n">3</span> Personalise it</div>' +
      '<div class="cvb-flab cvb-flab-row"><span>Background colour <span class="req">· required</span></span></div>' +
      '<div class="cvb-bg" id="coco-bg"></div>' +
      '<div class="cvb-bgsel">Selected: <strong id="coco-bgsel">—</strong></div>' +
      '<div class="cvb-lab"><span class="n">4</span> Need it fast?</div>' +
      '<div class="cvb-rush" id="cvb-rush"><span class="cvb-tog"><span class="k"></span></span><div style="flex:1"><div style="font-weight:600;font-size:15px">⚡ Rush order — 48 hours</div><div style="font-size:13px;color:var(--coco-bx-subtext,#8a857d)">Skip the queue, proof in 2 days</div></div><span id="cvb-rushpr" style="font-weight:600;color:var(--coco-bx-accent,#D2694A);white-space:nowrap"></span></div>';
  
    function cvNum(s){ if(!s) return NaN; var t=String(s).replace(/[^\d.,]/g,''); if(!t) return NaN; if(t.indexOf(',')>-1&&t.indexOf('.')>-1){ if(t.lastIndexOf(',')>t.lastIndexOf('.')){t=t.replace(/\./g,'').replace(',','.');}else{t=t.replace(/,/g,'');} } else if(t.indexOf(',')>-1){ var p=t.split(','); t=(p[p.length-1].length===2)?t.replace(/,/g,'.'):t.replace(/,/g,''); } return parseFloat(t); }
    function cvSym(s){ var m=s?String(s).match(/^[^\d.,\s]+/):null; return m?m[0]:'$'; }
    function cvDelta(baseStr, valStr){ var b=cvNum(baseStr), v=cvNum(valStr); if(!isFinite(b)||!isFinite(v)||v<=b) return ''; return '+'+cvSym(baseStr)+Math.round(v-b); }
    function updateDeltas() {
      var e3040 = $('[data-pr="3040"]'), e4560 = $('[data-pr="4560"]'), erush = $('#cvb-rushpr');
      var d = DELTAS[String(st.people)];
      if (d) {
        if (e3040) e3040.textContent = cvDelta(d.base, d.f3040);
        if (e4560) e4560.textContent = cvDelta(d.base, d.f4560);
        if (erush) erush.textContent = cvDelta(d.base, d.rush);
        return;
      }
      var base = priceFor(st.people, st.rush, 'digital');
      var p3040 = priceFor(st.people, st.rush, '3040', st.colour);
      var p4560 = priceFor(st.people, st.rush, '4560', st.colour);
      if (e3040) e3040.textContent = (base != null && p3040 != null && p3040 > base) ? '+$' + Math.round((p3040 - base)/100) : '';
      if (e4560) e4560.textContent = (base != null && p4560 != null && p4560 > base) ? '+$' + Math.round((p4560 - base)/100) : '';
      var rOff = priceFor(st.people, false, st.finish, st.colour);
      var rOn = priceFor(st.people, true, st.finish, st.colour);
      if (erush) erush.textContent = (rOff != null && rOn != null && rOn > rOff) ? '+$' + Math.round((rOn - rOff)/100) : '';
    }
    function render() {
      all('.cvb-pp').forEach(function (b) { b.classList.toggle('act', b.getAttribute('data-p') === String(st.people)); });
      all('.cvb-opt').forEach(function (o) { var f = o.getAttribute('data-f'); var oos = !sizeAvail(st.people, st.rush, f); o.classList.toggle('cvb-soldout', oos); o.classList.toggle('act', f === st.finish && !oos); });
      all('.cvb-cc').forEach(function (c) { var cl = c.getAttribute('data-c'); var oos = !availFor(st.people, st.rush, st.finish, cl); c.classList.toggle('cvb-soldout', oos); c.classList.toggle('act', cl === st.colour && !oos); });
      var col = $('#cvb-col');
      if (st.finish === 'digital') { col.classList.remove('open'); }
      else {
        var card = root.querySelector('.cvb-opt[data-f="' + st.finish + '"]');
        if (card && card.nextElementSibling !== col) card.after(col);
        col.classList.add('open');
      }
      $('#cvb-rush').classList.toggle('act', st.rush);
    }
  
    /* ========== ATC BUTTON LOCK & MISSING‑FIELD BADGE (BG + UPLOAD) ========== */
    var submitAttempted = false;
  
    // Required fields: background colour AND uploaded image (coco-photo-upload)
    function isUploadedImageSet() {
      // Prefer coco-photo-upload state (does not mutate that snippet)
      if (window.__cocoUploadedFile) return true;
      var wrap = document.getElementById('coco-photo-upload');
      if (wrap) {
        if (wrap.classList.contains('coco-upload-invalid')) return false;
        var fileInput = document.getElementById('coco-photo-input') ||
          wrap.querySelector('input[type="file"][name="properties[Uploaded image]"]');
        if (fileInput && fileInput.files && fileInput.files.length > 0) return true;
        // Valid when upload UI cleared the invalid class after accept()
        return !wrap.classList.contains('coco-upload-invalid');
      }
      // Fallback: UploadKit / generic property field (other templates)
      var input = document.querySelector('input[name="properties[Uploaded image]"]');
      if (!input) return false;
      if (input.type === 'file') return !!(input.files && input.files.length);
      return input.value.trim().length > 0;
    }
  
    function areFieldsValid() {
      var bgOk = !!st.bg;
      var imageOk = isUploadedImageSet();
      return bgOk && imageOk;
    }
  
    function getMissingFieldsEl() {
      var el = document.getElementById('coco-missing-fields');
      if (!el) {
        el = document.createElement('div');
        el.id = 'coco-missing-fields';
      }
  
      // Place after coco-photo-upload (preferred), then UploadKit, then rush/bg
      var anchor = document.getElementById('coco-photo-upload') ||
                   document.querySelector('.uploadkit.uploadkit-injected');
      if (anchor && anchor.parentNode) {
        if (anchor.nextSibling !== el) {
          anchor.parentNode.insertBefore(el, anchor.nextSibling);
        }
      } else if (!el.parentNode) {
        var rushSection = document.getElementById('cvb-rush');
        if (rushSection && rushSection.parentNode) {
          rushSection.parentNode.insertBefore(el, rushSection.nextSibling);
        } else {
          var bgEl = document.getElementById('coco-bg');
          if (bgEl && bgEl.parentNode) {
            bgEl.parentNode.insertBefore(el, bgEl.nextSibling);
          } else {
            document.body.appendChild(el);
          }
        }
      }
      return el;
    }
  
    function updateATCButtonState() {
      var btn = getATCButton();
      if (!btn) return;
      var valid = areFieldsValid();
  
      if (valid) {
        btn.disabled = false;
        btn.removeAttribute('disabled');
        btn.classList.remove('coco-atc-locked');
        btn.removeEventListener('click', interceptClick);
      } else {
        btn.disabled = true;
        btn.setAttribute('disabled', '');
        btn.classList.add('coco-atc-locked');
        btn.addEventListener('click', interceptClick, true);
      }
  
      // Badge (only after a failed attempt)
      var msgEl = getMissingFieldsEl();
      if (submitAttempted && !valid) {
        var missing = [];
        if (!st.bg) missing.push('a background colour');
        if (!isUploadedImageSet()) missing.push('an uploaded image');
        var msg = '⚠️ Before we can add this to your cart, please select ' + missing.join(' and ') + '.';
        msgEl.innerHTML = msg;
        msgEl.classList.add('visible');
      } else {
        msgEl.classList.remove('visible');
      }
    }
  
    function interceptClick(e) {
      var btn = getATCButton();
      if (btn && (btn.disabled || btn.classList.contains('coco-atc-locked'))) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        submitAttempted = true;
        updateATCButtonState();
      }
    }
  
    // Initial lock and protection against external re‑enable
    (function disableButtonInitially() {
      var buyWrapper = document.querySelector('.product-info buy-buttons');
      if (buyWrapper) {
        buyWrapper.addEventListener('click', function(e) {
          var btn = getATCButton();
          if (btn && (btn.disabled || btn.classList.contains('coco-atc-locked'))) {
            e.preventDefault();
            e.stopPropagation();
            submitAttempted = true;
            updateATCButtonState();
          }
        }, true);
      }
      function disable() {
        var btn = getATCButton();
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('disabled', '');
          btn.classList.add('coco-atc-locked');
          btn.addEventListener('click', interceptClick, true);
          observeButtonForChanges(btn);
        } else {
          setTimeout(disable, 50);
        }
      }
  
      function observeButtonForChanges(btn) {
        var observer = new MutationObserver(function (mutations) {
          if (!btn.disabled && !btn.hasAttribute('disabled')) {
            btn.disabled = true;
            btn.setAttribute('disabled', '');
            btn.classList.add('coco-atc-locked');
          }
          if (!btn.classList.contains('coco-atc-locked')) {
            btn.classList.add('coco-atc-locked');
          }
        });
        observer.observe(btn, { attributes: true, attributeFilter: ['disabled', 'class'] });
        setTimeout(function () { observer.disconnect(); }, 30000);
      }
  
      disable();
    })();
  
    // Photo events also rebound in bindCartProperties section below (ATC + form props)

    var uploadObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node.nodeType === 1) {
              if (node.id === 'coco-photo-upload' ||
                  (node.matches && node.matches('input[name="properties[Uploaded image]"]')) ||
                  (node.querySelector && (
                    node.querySelector('#coco-photo-upload') ||
                    node.querySelector('input[name="properties[Uploaded image]"]')
                  ))) {
                updateATCButtonState();
                return;
              }
            }
          }
        } else if (m.type === 'attributes') {
          var t = m.target;
          if (t && t.matches) {
            if (t.id === 'coco-photo-upload' ||
                t.matches('input[name="properties[Uploaded image]"]') ||
                t.id === 'coco-photo-input') {
              updateATCButtonState();
              return;
            }
          }
        }
      }
    });
    uploadObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'class', 'hidden']
    });
  
    /* ========== BUTTON PRICE UPDATE (unchanged logic) ========== */
    function getATCButton() {
      return (pform && (pform.querySelector('button[type="submit"]') ||
                        pform.querySelector('input[type="submit"]'))) ||
             document.querySelector('.product-info button[type="submit"]') ||
             document.querySelector('button[name="add"]') ||
             document.querySelector('button[type="submit"]');
    }
  
    function updateATCPrice() {
      var variant = null;
      var people = String(st.people);
      var rush = rushVal();
      var framing = frameVal();
      for (var i = 0; i < VARS.length; i++) {
        var v = VARS[i];
        if (String(v.option1) === people &&
            v.option2 === rush.toLowerCase() &&
            v.option3 === framing) {
          variant = v;
          break;
        }
      }
      if (!variant) return;
  
      var addBtn = getATCButton();
      if (!addBtn) return;
  
      var sym = (DATA.currencySymbol || '$').replace(/<[^>]*>/g, '').trim();
      var formatMoney = function(cents) {
        var num = (cents / 100).toFixed(2);
        var parts = num.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return sym + parts.join('.');
      };
  
      var priceCents = variant.price;
      var compareCents = variant.compare_at_price || null;
  
      var lbl = addBtn.querySelector('.coco-btn-price');
      if (!lbl) {
        lbl = document.createElement('span');
        lbl.className = 'coco-btn-price';
        addBtn.appendChild(lbl);
      }
      lbl.innerHTML = '<span class="bp-cur">' + formatMoney(priceCents) + '</span>' +
                      (compareCents && compareCents > priceCents
                        ? ' <span class="bp-was">' + formatMoney(compareCents) + '</span>'
                        : '');
  
      var saveEl = document.getElementById('coco-atc-savings');
      if (!saveEl) {
        saveEl = document.createElement('div');
        saveEl.id = 'coco-atc-savings';
        var container = addBtn.closest('buy-buttons') || addBtn.closest('.product-info__buy-buttons') || addBtn.parentElement;
        if (container) {
          container.parentNode.insertBefore(saveEl, container.nextSibling);
        } else {
          addBtn.parentNode.insertBefore(saveEl, addBtn.nextSibling);
        }
      }
  
      if (compareCents && compareCents > priceCents) {
        var saved = compareCents - priceCents;
        var pct = Math.round((saved / compareCents) * 100);
        saveEl.style.display = 'block';
        saveEl.innerHTML = 'You save <strong>' + formatMoney(saved) + '</strong> (' + pct + '%) today';
        addBtn.classList.add('has-savings');
      } else {
        saveEl.style.display = 'none';
        saveEl.innerHTML = '';
        addBtn.classList.remove('has-savings');
      }
    }
  
    function initPrice() {
      if (getATCButton()) {
        updateATCPrice();
      } else {
        setTimeout(initPrice, 50);
      }
    }
  
    var originalApply = function() { normalizeSelection(); syncNative(); render(); updateDeltas(); cocoEnforce(); };
    window.apply = function() {
      originalApply();
      updateATCPrice();
      // After state change, re‑evaluate lock
      updateATCButtonState();
    };
    var apply = window.apply;
  
    function cocoProds() {
      if (!window.__cocoProdJs) {
        window.__cocoProdJs = fetch(location.pathname.replace(/\/+$/, '') + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return window.__cocoProdJs;
    }
    function fmtMoney(cents) {
      var sym = '$';
      try { var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || ''; sym = { GBP: '£', EUR: '€' }[cur] || '$'; } catch (e) {}
      return sym + (cents / 100).toFixed(2);
    }
    function matchesFrameOpt(opt) {
      var o = String(opt || '');
      if (st.finish === 'digital') return /no\s*frame|digital/i.test(o);
      var size = st.finish === '3040' ? /30\s*x\s*40/i : /45\s*x\s*60/i;
      return size.test(o) && o.toLowerCase().indexOf(st.colour.toLowerCase()) > -1;
    }
    function cocoEnforce() {
      cocoProds().then(function (p) {
        if (!p || !p.variants) return;
        var hit = null;
        for (var i = 0; i < p.variants.length; i++) {
          var v = p.variants[i];
          if (String(v.option1).trim() !== String(st.people).trim()) continue;
          if ((/48\s*hours/i.test(String(v.option2 || ''))) !== !!st.rush) continue;
          if (!matchesFrameOpt(v.option3)) continue;
          hit = v; break;
        }
        if (!hit) return;
        Array.prototype.forEach.call(document.querySelectorAll('.product-info form[action*="/cart/add"] [name="id"]'), function (inp) { inp.value = String(hit.id); });
        var pl = document.querySelector('.product-info price-list');
        if (pl) {
          var sp = pl.querySelector('sale-price');
          if (sp) sp.innerHTML = '<span class="sr-only">Sale price</span>' + fmtMoney(hit.price);
          var cp = pl.querySelector('compare-at-price');
          if (cp) {
            if (hit.compare_at_price && hit.compare_at_price > hit.price) { cp.style.display = ''; cp.innerHTML = '<span class="sr-only">Regular price</span>' + fmtMoney(hit.compare_at_price); }
            else { cp.style.display = 'none'; }
          }
        }
      });
    }
  
    all('.cvb-pp').forEach(function (b) { b.addEventListener('click', function () { st.people = b.getAttribute('data-p'); apply(); }); });
    all('.cvb-opt').forEach(function (o) { o.addEventListener('click', function () { if (o.classList.contains('cvb-soldout')) return; st.finish = o.getAttribute('data-f'); apply(); }); });
    all('.cvb-cc').forEach(function (c) { c.addEventListener('click', function () { if (c.classList.contains('cvb-soldout')) return; st.colour = c.getAttribute('data-c'); apply(); }); });
    $('#cvb-rush').addEventListener('click', function () { st.rush = !st.rush; apply(); });
  
    apply(); // initial render + price + lock
  
    var mo = new MutationObserver(function () { if (vopoReady()) syncNative(); });
    mo.observe(scope, { childList: true, subtree: true });
    if (vopoReady()) syncNative();
    setTimeout(function () { mo.disconnect(); }, 20000);
  
    /* ========== BACKGROUND COLOUR (ROBUST) ========== */
    var COLOURS = [
      { n: 'White', h: '#ffffff' }, { n: 'Grey', h: '#dad5d3' }, { n: 'Rust', h: '#e0c8bc' },
      { n: 'Taupe', h: '#ece5e1' }, { n: 'Chestnut', h: '#e3d5c9' }, { n: 'Dusk', h: '#cfb9b2' },
      { n: 'Peach', h: '#eebda7' }, { n: 'Sage', h: '#b5b5a2' }, { n: 'Grey/Blue', h: '#dee6e5' },
      { n: 'Blush', h: '#f3dbd7' }
    ];
    try { var _customBg = JSON.parse(root.dataset.bg || '[]'); if (_customBg && _customBg.length) COLOURS = _customBg; } catch (e) {}
    
    var bgWrap = $('#coco-bg'), bgSel = $('#coco-bgsel');
    
    var hiddenBgInput = document.createElement('input');
    hiddenBgInput.type = 'hidden';
    hiddenBgInput.name = 'properties[Background]';
    // Keep on root for UI ownership; bind to product form via `form` attr below
    root.appendChild(hiddenBgInput);
    
    function selectColour(name) {
      st.bg = name;
      hiddenBgInput.value = name;
      setBgNative(name);
      if (bgSel) bgSel.textContent = name;
      if (bgWrap) {
        bgWrap.classList.remove('cvb-err');
        Array.prototype.forEach.call(bgWrap.children, function (x) {
          x.classList.toggle('act', x.getAttribute('data-c') === name);
        });
      }
      var popup = document.getElementById('coco-bgpreview');
      if (popup && popup.classList.contains('open')) {
        Array.prototype.forEach.call(popup.querySelectorAll('.pv-tile'), function (t) {
          t.classList.toggle('sel', t.getAttribute('data-c') === name);
        });
      }
      // Re‑evaluate lock: background is now set
      updateATCButtonState();
    }
    
    if (bgWrap) {
      COLOURS.forEach(function (c) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'cvb-chip';
        chip.setAttribute('data-c', c.n);
        chip.title = c.n;
        chip.setAttribute('aria-label', c.n);
        if (c.h) chip.style.background = c.h;
        if (c.img) chip.setAttribute('data-img', c.img);
        chip.addEventListener('click', function () { selectColour(c.n); });
        bgWrap.appendChild(chip);
      });
    }
    
    if (st.bg) selectColour(st.bg);
  
    /* ========== VALIDATION & FORM (cart line-item properties) ========== */
    var pform = (function(){var __b=document.querySelector('.product-info__buy-buttons button[type="submit"]')||document.querySelector('.product-info buy-buttons button[type="submit"]')||document.querySelector('.product-info button[type="submit"][name="add"]');var __f=__b&&__b.closest('form[action*="/cart/add"]');return __f||document.querySelector('.product-info__buy-buttons form[action*="/cart/add"]')||document.querySelector('.product-info form[action*="/cart/add"]')||document.querySelector('form[action*="/cart/add"]');})();

    // Bind Background + Uploaded image onto the real product form so they appear in cart.
    // Flow: customer selects photo FIRST → then ATC → file uploads WITH cart/add (multipart).
    // (coco-photo-upload markup sits outside the form; do not edit that snippet.)
    function ensureProductFormId(form) {
      if (!form) return '';
      if (!form.id) form.id = 'coco-people-product-form';
      return form.id;
    }

    function getUploadedFile() {
      if (window.__cocoUploadedFile) return window.__cocoUploadedFile;
      var photoInput = document.getElementById('coco-photo-input');
      if (photoInput && photoInput.files && photoInput.files[0]) return photoInput.files[0];
      return null;
    }

    function getVariantIdFromForm(form) {
      form = form || pform;
      if (!form) return '';
      var idInput = form.querySelector('[name="id"]');
      return idInput && idInput.value ? String(idInput.value) : '';
    }

    function bindCartProperties(form) {
      form = form || pform;
      if (!form) return false;
      var formId = ensureProductFormId(form);

      // Background colour → line item property
      if (hiddenBgInput) {
        hiddenBgInput.name = 'properties[Background]';
        hiddenBgInput.setAttribute('form', formId);
        if (st.bg) hiddenBgInput.value = st.bg;
      }
      Array.prototype.forEach.call(form.querySelectorAll('input[name="properties[Background]"]'), function (el) {
        if (el === hiddenBgInput) return;
        if (el.type === 'hidden' && el.parentNode === form) el.parentNode.removeChild(el);
      });

      // Uploaded image file → Shopify line item file property (sent on ATC, not before)
      var photoInput = document.getElementById('coco-photo-input') ||
        document.querySelector('#coco-photo-upload input[type="file"]');
      if (photoInput) {
        photoInput.name = 'properties[Uploaded image]';
        photoInput.setAttribute('form', formId);
        if (window.__cocoUploadedFile && !(photoInput.files && photoInput.files.length)) {
          try {
            var dt = new DataTransfer();
            dt.items.add(window.__cocoUploadedFile);
            photoInput.files = dt.files;
          } catch (err) {}
        }
      }
      var photoWrap = document.getElementById('coco-photo-upload');
      if (photoWrap) photoWrap.setAttribute('data-form-id', formId);

      // Empty text fields with the same name overwrite the file in cart — neutralize them
      Array.prototype.forEach.call(
        document.querySelectorAll('input[name="properties[Uploaded image]"]'),
        function (el) {
          if (el === photoInput) return;
          if (el.type === 'file') return;
          el.removeAttribute('name');
          el.disabled = true;
          el.value = '';
        }
      );

      return true;
    }

    function buildCartAddFormData(form) {
      form = form || pform;
      bindCartProperties(form);
      var fd = form ? new FormData(form) : new FormData();
      var file = getUploadedFile();
      var variantId = getVariantIdFromForm(form);
      if (variantId) fd.set('id', variantId);
      if (!fd.get('quantity')) fd.set('quantity', '1');
      if (st.bg) fd.set('properties[Background]', st.bg);
      if (file) fd.set('properties[Uploaded image]', file, file.name || 'upload.jpg');
      return fd;
    }

    function refreshCartUI() {
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('theme:cart:change'));
        if (window.theme && typeof window.theme.cartGet === 'function') window.theme.cartGet();
      } catch (e) {}
    }

    function goToCartPage() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = root + 'cart';
    }

    // Own ATC when photo upload is present: themes often POST JSON (no files).
    // We always POST multipart FormData so Shopify stores the uploaded image on the line item.
    var __cocoAdding = false;
    function addToCartWithUpload(form, triggerBtn) {
      if (__cocoAdding) return Promise.resolve();
      if (window.__cocoBoxValidate && window.__cocoBoxValidate() === false) {
        submitAttempted = true;
        updateATCButtonState();
        return Promise.resolve(false);
      }
      var file = getUploadedFile();
      if (!file) {
        submitAttempted = true;
        updateATCButtonState();
        return Promise.resolve(false);
      }
      __cocoAdding = true;
      if (triggerBtn) {
        triggerBtn.setAttribute('aria-busy', 'true');
        triggerBtn.classList.add('is-loading');
      }
      var fd = buildCartAddFormData(form);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (res) {
        if (!res.ok) return res.json().catch(function () { return {}; }).then(function (err) {
          throw err;
        });
        return res.json();
      }).then(function () {
        // After upload + add, go to the cart page (not drawer)
        goToCartPage();
        return true;
      }).catch(function (err) {
        console.warn('[coco] cart/add with upload failed', err);
        alert((err && (err.description || err.message)) || 'Could not add to cart. Please try again.');
        __cocoAdding = false;
        if (triggerBtn) {
          triggerBtn.removeAttribute('aria-busy');
          triggerBtn.classList.remove('is-loading');
        }
        return false;
      });
    }

    if (pform) {
      bindCartProperties(pform);
      setTimeout(function () { bindCartProperties(pform); }, 500);
      setTimeout(function () { bindCartProperties(pform); }, 1500);
    }

    // Patch fetch: if theme still fires /cart/add itself, force file + Background into the body
    if (!window.__cocoCartFetchHook) {
      window.__cocoCartFetchHook = 1;
      var _cocoFetch = window.fetch;
      if (typeof _cocoFetch === 'function') {
        window.fetch = function (input, init) {
          try {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            if (/\/cart\/add/.test(url) && document.getElementById('coco-cvb') && document.getElementById('coco-photo-upload')) {
              bindCartProperties(pform);
              init = init ? Object.assign({}, init) : {};
              var file = getUploadedFile();
              var body = init.body;
              var isFD = typeof FormData !== 'undefined' && body instanceof FormData;
              var ct = '';
              if (init.headers) {
                if (typeof Headers !== 'undefined' && init.headers instanceof Headers) {
                  ct = init.headers.get('Content-Type') || init.headers.get('content-type') || '';
                } else if (typeof init.headers === 'object') {
                  ct = init.headers['Content-Type'] || init.headers['content-type'] || '';
                }
              }
              var isJson = /application\/json/i.test(ct) ||
                (typeof body === 'string' && /^\s*\{/.test(body));

              if (isFD) {
                if (st.bg) body.set('properties[Background]', st.bg);
                if (file) body.set('properties[Uploaded image]', file, file.name || 'upload.jpg');
                init.body = body;
              } else if (file && isJson) {
                // Theme used JSON (cannot carry files) → rebuild as multipart
                var data = {};
                try { data = typeof body === 'string' ? JSON.parse(body) : (body || {}); } catch (e1) { data = {}; }
                var fd = new FormData();
                var item = data.items && data.items[0] ? data.items[0] : data;
                if (item.id) fd.append('id', String(item.id));
                else {
                  var vid = getVariantIdFromForm(pform);
                  if (vid) fd.append('id', vid);
                }
                fd.append('quantity', String(item.quantity != null ? item.quantity : 1));
                var props = item.properties || data.properties || {};
                Object.keys(props).forEach(function (k) {
                  if (k === 'Uploaded image') return;
                  fd.append('properties[' + k + ']', props[k] == null ? '' : String(props[k]));
                });
                if (st.bg) fd.append('properties[Background]', st.bg);
                fd.append('properties[Uploaded image]', file, file.name || 'upload.jpg');
                init.body = fd;
                if (init.headers) {
                  var h = init.headers;
                  if (typeof Headers !== 'undefined' && h instanceof Headers) {
                    h = new Headers(h);
                    h.delete('Content-Type');
                    init.headers = h;
                  } else if (h && typeof h === 'object') {
                    h = Object.assign({}, h);
                    delete h['Content-Type'];
                    delete h['content-type'];
                    init.headers = h;
                  }
                }
              }
            }
          } catch (e2) {}
          return _cocoFetch.call(this, input, init);
        };
      }
    }

    window.__cocoBoxValidate = function () {
      bindCartProperties(pform);
      if (!st.bg) { var bw = document.getElementById('coco-bg'); if (bw) { bw.classList.add('cvb-err'); try { bw.scrollIntoView({ block: 'center' }); } catch (_e) {} } return false; }
      if (!isUploadedImageSet()) {
        var photo = document.getElementById('coco-photo-upload');
        if (photo) {
          photo.classList.add('cu-show-err');
          try { photo.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_e) {}
          photo.style.boxShadow = '0 0 0 3px #D2694A';
          photo.style.borderRadius = '12px';
          setTimeout(function () { photo.style.boxShadow = ''; }, 3000);
        } else {
          var f = document.querySelector('input[name="properties[Uploaded image]"]') ||
                  document.querySelector('.uploadkit-upload-field:not([style*="display: none"])');
          if (f) { f.classList.add('uploadkit-invalid'); try { f.scrollIntoView({ block: 'center' }); } catch (_e2) {} }
        }
        return false;
      }
      var __uk = document.querySelector('.uploadkit-invalid');
      if (__uk && !document.getElementById('coco-photo-upload')) {
        var __uf = document.querySelector('.uploadkit-upload-field') || __uk;
        try { __uf.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_e) {}
        __uf.style.boxShadow = '0 0 0 3px #D2694A';
        __uf.style.borderRadius = '12px';
        setTimeout(function () { __uf.style.boxShadow = ''; }, 3000);
        return false;
      }
      return true;
    };

    // Intercept ATC: upload image WITH cart add (after photo is selected)
    if (!window.__cocoUploadAtcHook) {
      window.__cocoUploadAtcHook = 1;
      document.addEventListener('click', function (e) {
        if (!document.getElementById('coco-cvb') || !document.getElementById('coco-photo-upload')) return;
        var btn = e.target && e.target.closest && e.target.closest(
          'button[type="submit"][name="add"], buy-buttons button[type="submit"], .product-info button[type="submit"], button[name="add"]'
        );
        if (!btn) return;
        var form = btn.closest('form[action*="/cart/add"]') || pform;
        if (!form) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        addToCartWithUpload(form, btn);
      }, true);

      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.getAttribute) return;
        if (String(f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
        if (!document.getElementById('coco-cvb') || !document.getElementById('coco-photo-upload')) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        bindCartProperties(f);
        addToCartWithUpload(f, f.querySelector('[type="submit"]'));
      }, true);
    }

    // Keep form binding fresh when a photo is chosen/cleared
    document.addEventListener('coco:photo-selected', function () { bindCartProperties(pform); updateATCButtonState(); });
    document.addEventListener('coco:photo-cleared', function () { bindCartProperties(pform); updateATCButtonState(); });
  
    // Payment icons
    (function () {
      var bb = scope.querySelector('buy-buttons') || scope.querySelector('button[type="submit"]');
      if (!bb || document.getElementById('coco-pay')) return;
      var PAY = [
        { n: 'Visa', s: '<svg viewBox="0 0 48 16"><text x="24" y="13" font-family="Arial,Helvetica,sans-serif" font-weight="800" font-style="italic" font-size="15" fill="#1A1F71" text-anchor="middle" letter-spacing="1">VISA</text></svg>' },
        { n: 'Mastercard', s: '<svg viewBox="0 0 40 24"><circle cx="15.5" cy="12" r="8" fill="#EB001B"/><circle cx="24.5" cy="12" r="8" fill="#F79E1B"/><path d="M20 5.6a8 8 0 0 0 0 12.8 8 8 0 0 0 0-12.8z" fill="#FF5F00"/></svg>' },
        { n: 'American Express', c: 'amex', s: '<svg viewBox="0 0 48 14"><text x="24" y="11.5" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="9" fill="#fff" text-anchor="middle" letter-spacing="1">AMEX</text></svg>' },
        { n: 'Apple Pay', c: 'applepay', s: '<svg viewBox="0 0 56 22"><path d="M11.9 6.6c-.6.7-1.5 1.2-2.3 1.1-.1-.9.3-1.8.8-2.3.6-.7 1.5-1.2 2.3-1.2.1.9-.3 1.7-.8 2.4zM12.7 7.9c-1.2-.07-2.3.7-2.9.7-.6 0-1.5-.68-2.5-.66-1.28.02-2.46.74-3.12 1.88-1.32 2.3-.34 5.7.95 7.57.63.9 1.38 1.92 2.36 1.89.95-.04 1.31-.61 2.46-.61 1.14 0 1.46.61 2.46.59 1.02-.02 1.66-.92 2.28-1.84.72-1.05 1.02-2.07 1.04-2.13-.02-.01-1.99-.77-2.01-3.02-.02-1.88 1.54-2.78 1.61-2.83-.88-1.3-2.25-1.45-2.73-1.49z" fill="#fff"/><text x="22" y="16" font-family="Arial,Helvetica,sans-serif" font-weight="600" font-size="13" fill="#fff">Pay</text></svg>' },
        { n: 'Google Pay', s: '<svg viewBox="0 0 56 20"><text x="2" y="15" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="14" fill="#4285F4">G</text><text x="15" y="15" font-family="Arial,Helvetica,sans-serif" font-weight="500" font-size="13" fill="#5F6368">Pay</text></svg>' },
        { n: 'Shop Pay', c: 'shoppay', s: '<svg viewBox="0 0 70 18"><text x="35" y="14" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="12.5" fill="#fff" text-anchor="middle">shop Pay</text></svg>' },
        { n: 'PayPal', s: '<svg viewBox="0 0 58 16"><text x="2" y="13" font-family="Arial,Helvetica,sans-serif" font-weight="800" font-style="italic" font-size="13" fill="#003087">Pay</text><text x="26" y="13" font-family="Arial,Helvetica,sans-serif" font-weight="800" font-style="italic" font-size="13" fill="#009CDE">Pal</text></svg>' },
        { n: 'Afterpay', s: '<svg viewBox="0 0 70 16"><text x="2" y="13" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="12.5" fill="#000">after</text><text x="36" y="13" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="12.5" fill="#00C2A8">pay</text></svg>' },
        { n: 'Klarna', c: 'klarna', s: '<svg viewBox="0 0 56 18"><text x="28" y="14" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="12.5" fill="#0A0B09" text-anchor="middle">Klarna</text></svg>' },
        { n: 'Zip', s: '<svg viewBox="0 0 40 18"><text x="20" y="14" font-family="Arial,Helvetica,sans-serif" font-weight="800" font-size="14" fill="#1A1A1A" text-anchor="middle">zip</text></svg>' }
      ];
      var wrap = document.createElement('div');
      wrap.id = 'coco-pay'; wrap.className = 'coco-pay';
      PAY.forEach(function (p) { var b = document.createElement('span'); b.className = 'coco-pay-badge' + (p.c ? ' ' + p.c : ''); b.setAttribute('aria-label', p.n); b.title = p.n; b.innerHTML = p.s; wrap.appendChild(b); });
      var anchor = document.getElementById('coco-atc-savings') || bb;
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    })();
  
    // Initial price update (retry until button appears)
    initPrice();
  })();
  
  /* Coco — "See each colour" background popup (unchanged) */
  (function () {
    function init() {
      var bgWrap = document.getElementById('coco-bg');
      var labRow = document.querySelector('#coco-cvb .cvb-flab-row');
      if (!bgWrap || !labRow) return false;
      if (document.getElementById('coco-bgpreview')) return true;
      var chips = Array.prototype.slice.call(bgWrap.querySelectorAll('.cvb-chip'));
      if (!chips.length) return false;
  
      var BASE = 'https://cdn.shopify.com/s/files/1/0256/6409/4296/files/coco-ci-bg-';
      var slug = function (n) { return n.toLowerCase().replace(/[\/ ]+/g, '-'); };
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.id = 'coco-bgpv-open';
      btn.className = 'cvb-seeall';
      btn.textContent = 'See each colour';
      labRow.appendChild(btn);
  
      var stl = document.createElement('style');
      stl.textContent =
        '#coco-cvb .cvb-flab-row{display:flex;align-items:center;gap:10px;}' +
        '#coco-cvb .cvb-seeall{margin-left:auto;background:none;border:0;color:var(--coco-bx-heading,#2A555A);font-size:13px;font-weight:600;text-decoration:underline;cursor:pointer;padding:0;white-space:nowrap;}' +
        '#coco-cvb .cvb-seeall:hover{color:var(--coco-bx-accent,#D2694A);}' +
        '#coco-bgpreview{position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;background:rgba(28,28,26,.55);padding:18px;}' +
        '#coco-bgpreview.open{display:flex;}' +
        '#coco-bgpreview .pv-panel{background:var(--coco-bx-panel-bg,#FBF8F2);border-radius:16px;max-width:760px;width:100%;max-height:90vh;overflow:auto;padding:20px 20px 24px;box-shadow:0 12px 50px rgba(0,0,0,.35);}' +
        '#coco-bgpreview .pv-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;}' +
        '#coco-bgpreview .pv-head h3{margin:0;font-family:var(--heading-font-family,inherit);color:var(--coco-bx-heading,#2A555A);font-size:19px;}' +
        '#coco-bgpreview .pv-x{background:none;border:0;font-size:26px;line-height:1;color:var(--coco-bx-subtext,#8a857d);cursor:pointer;padding:0 4px;}' +
        '#coco-bgpreview .pv-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:12px;}' +
        '#coco-bgpreview .pv-tile{border:2px solid transparent;border-radius:12px;overflow:hidden;cursor:pointer;background:#fff;padding:0;text-align:center;}' +
        '#coco-bgpreview .pv-tile img{width:100%;display:block;aspect-ratio:81/144;object-fit:cover;}' +
        '#coco-bgpreview .pv-tile .nm{display:block;font-size:12.5px;font-weight:600;color:#2c2c2a;padding:7px 6px;}' +
        '#coco-bgpreview .pv-tile.sel{border-color:var(--coco-bx-heading,#2A555A);}' +
        '#coco-bgpreview .pv-tile:hover{border-color:var(--coco-bx-accent,#D2694A);}';
      document.head.appendChild(stl);
  
      var ov = document.createElement('div');
      ov.id = 'coco-bgpreview';
      var tiles = chips.map(function (chip) {
        var n = chip.getAttribute('data-c');
        var src = chip.getAttribute('data-img') || (BASE + slug(n) + '.png');
        return '<button type="button" class="pv-tile" data-c="' + n + '">' +
          '<img loading="lazy" src="' + src + '" alt="' + n + ' background">' +
          '<span class="nm">' + n + '</span></button>';
      }).join('');
      ov.innerHTML =
        '<div class="pv-panel"><div class="pv-head">' +
        '<h3>See it in every background</h3>' +
        '<button type="button" class="pv-x" aria-label="Close">&times;</button></div>' +
        '<div class="pv-grid">' + tiles + '</div></div>';
      document.body.appendChild(ov);
  
      function curName() { var s = document.getElementById('coco-bgsel'); return s ? s.textContent.trim() : ''; }
      function open() {
        var c = curName();
        Array.prototype.forEach.call(ov.querySelectorAll('.pv-tile'), function (t) {
          t.classList.toggle('sel', t.getAttribute('data-c') === c);
        });
        ov.classList.add('open');
      }
      function close() { ov.classList.remove('open'); }
  
      btn.addEventListener('click', open);
      ov.addEventListener('click', function (e) {
        if (e.target === ov || e.target.classList.contains('pv-x')) { close(); return; }
        var t = e.target.closest('.pv-tile');
        if (t) {
          if (typeof selectColour === 'function') {
            selectColour(t.getAttribute('data-c'));
          } else {
            var chip = bgWrap.querySelector('.cvb-chip[data-c="' + t.getAttribute('data-c') + '"]');
            if (chip) chip.click();
          }
          close();
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      return true;
    }
  
    if (!init()) {
      var tries = 0;
      var iv = setInterval(function () { tries++; if (init() || tries > 40) clearInterval(iv); }, 250);
    }
  })();
  
  (function () {
    // Sticky bar "Create Now"
    if (window.__cocoStickyHook) return; window.__cocoStickyHook = 1;
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('#foxdos_atc_button_trigger');
      if (!t) return;
      var box = document.getElementById('coco-cvb');
      if (!box) return;
      e.preventDefault(); e.stopPropagation();
      var r = box.getBoundingClientRect();
      if (r.top < 0 || r.bottom > (window.innerHeight || 800)) {
        setTimeout(function () { try { box.scrollIntoView({ block: 'start' }); } catch (_x) {} }, 20);
        return;
      }
      var b = document.querySelector('.product-info buy-buttons button[type="submit"]') || document.querySelector('.product-info button[type="submit"][name="add"]');
      var f = b && b.closest('form[action*="/cart/add"]');
      if (f) { try { if (f.requestSubmit) f.requestSubmit(b); else f.submit(); } catch (err) {} }
    }, true);
  })();
  
  (function () {
    if (window.__cocoPeopleSentinel) return; window.__cocoPeopleSentinel = 1;
    var src = document.currentScript && document.currentScript.src;
    if (!src) { var sc = document.querySelector('script[src*="coco-people.js"]'); src = sc && sc.src; }
    if (!src) return;
    var busy = false;
    setInterval(function () {
      var r = document.getElementById('coco-cvb');
      if (!r || r.dataset.cocoInit || busy) return;
      busy = true;
      var s = document.createElement('script');
      s.src = src;
      s.onload = s.onerror = function () { busy = false; setTimeout(function () { try { s.remove(); } catch (_e) {} }, 0); };
      document.head.appendChild(s);
    }, 700);
  })();